import { createClient } from '@/lib/supabase/browser';

export const JOB_LISTING_COLUMNS = [
  'id', 'title', 'company', 'description', 'job_type',
  'location', 'rate', 'tags', 'created_at', 'posted_by',
  'is_archived', 'allow_multi_character', 'audition_lines',
  'status', 'post_removal_date',
].join(', ');

// Base query for all public job listings — always published + not archived
export function publicJobsQuery(supabase: ReturnType<typeof createClient>) {
  return supabase
    .from('job_postings')
    .select(JOB_LISTING_COLUMNS)
    .eq('status', 'published')
    .eq('is_archived', false);
}

// Head-only count of public jobs that went live after `sinceIso`. Mirrors
// publicJobsQuery's visibility filter (published + not archived) so the nav
// "new jobs" dot never counts pending/hidden jobs. `created_at` is the
// timestamp the public listing itself carries/orders by. No rows transferred,
// no FK joins.
export async function countVisibleJobsSince(
  supabase: ReturnType<typeof createClient>,
  sinceIso: string
): Promise<number> {
  const { count } = await supabase
    .from('job_postings')
    .select('id', { count: 'exact', head: true })
    .eq('status', 'published')
    .eq('is_archived', false)
    .gt('created_at', sinceIso);
  return count ?? 0;
}
